import { axiosInstance } from "../axios-Instance";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../react-query/constants";
import { getLoginToken } from "../storage";

async function getAllMyEOI() {
  const data = await axiosInstance({
    url: "/eoi/me",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

async function getEOIByRound(formData: string) {
  const data = await axiosInstance({
    url: `/eoi/admin/${formData}`,
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

const expressinterest = async (formData: any) => {
  const data = await axiosInstance({
    url: "/eoi",
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const withdrawInterest = async (formData: any) => {
  const data = await axiosInstance({
    url: `/eoi/${formData}`,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

export function useMyEOI() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.eoi],
    queryFn: () => getAllMyEOI(),
  });
  return data;
}

export function useGetEOIByRound(formData: string) {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.roundEOI],
    queryFn: () => getEOIByRound(formData),
  });
  return data;
}

export function useExpressInterest() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => expressinterest(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.availableBids]);
      //   queryClient.invalidateQueries([
      //     queryKeys.eoi,
      //     queryKeys.availableBids,
      //     queryKeys.bid,
      //     queryKeys.asset,
      //   ]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useWithdrawInterest() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => withdrawInterest(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.bid]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}
